<template>
    <v-container>
        <div class="custom_question-info mb-10">
            <v-toolbar flat>
                <v-card-actions>
                    <v-icon @click="$router.go(-1)" color="secondary"  style="margin-right: 10px">
                        mdi-arrow-left-thick
                    </v-icon>
                </v-card-actions>
                <v-toolbar-title style=""><b>Question {{question.questionId}}</b></v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

        <div v-if="typeOneQuestion">
            <v-card class="mt-4 custom_v-card">
                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3 mt-2">
                        <v-card-text class="pr-5">Statement</v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="mt-2 pr-5">
                            <b> {{question.questionStatement}}</b>
                        </div>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3 mt-2">
                        <v-card-text class="pr-5">Audio</v-card-text>
                    </v-col>
                    <template v-if="question.questionAudio==='null'">
                        No Audio Provided
                    </template>
                    <v-template v-else>
                        <v-col cols="6">
                            <audio 
                                ref="audioElm" 
                                :src="questionAud" 
                                controls
                                max-height="50"
                                min-height="50"
                                max-width="150"
                                min-width="150"
                                contain
                                elevation
                            >
                            </audio>
                        </v-col>
                    </v-template>
                </v-row>        
                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3">
                        <v-card-text class="pr-5">Key Sequence</v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="mt-2 pr-5">
                            <b> 
                                <v-chip v-for="key in question.questionKeySequence" :key="key" >
                                    {{key}} 
                                </v-chip>
                            </b>
                        </div>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3 mt-2">
                        <v-card-text class="pr-5">Status</v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="mt-2 pr-5">
                            <v-switch
                                v-model="question.questionStatus"
                                inset
                                dense
                                class="mt-2" 
                                color="blue"
                                disabled
                                :label="question.questionStatus ? 'Active' : 'Inactive'"
                            >
                            </v-switch>
                        </div>
                    </v-col>
                </v-row>   
            </v-card>
        </div>

        <div v-else>
            <v-card class="mt-4 custom_v-card">
                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3 mt-2">
                        <v-card-text class="pr-5">Statement</v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="mt-2 pr-5">
                            <b> {{question.questionStatement}}</b>
                        </div>
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3">
                        <v-card-text class="pr-5">Options</v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="mt-2 pr-5">
                            <b> 
                                <v-chip v-for="key in question.questionOptions" :key="key" >
                                    {{key}} 
                                </v-chip>
                            </b>
                        </div>
                    </v-col>
                </v-row>

                 <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3">
                        <v-card-text class="pr-5">Answers</v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="mt-2 pr-5">
                            <b> 
                                <v-chip v-for="key in question.questionAnswers" :key="key" >
                                    {{key}} 
                                </v-chip>
                            </b>
                        </div>
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3 mt-2">
                        <v-card-text class="pr-5">Audio</v-card-text>
                    </v-col>
                    <template v-if="question.questionAudio==='null'">
                        No Audio Provided
                    </template>
                    <v-template v-else>
                        <v-col cols="6">
                            <audio 
                                ref="audioElm" 
                                :src="questionAud" 
                                controls
                                max-height="50"
                                min-height="50"
                                max-width="150"
                                min-width="150"
                                contain
                                elevation
                            >
                            </audio>
                        </v-col>
                    </v-template>
                </v-row>        
                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3 mt-2">
                        <v-card-text class="pr-5">Status</v-card-text>
                    </v-col>
                    <v-col cols="6">
                        <div class="mt-2 pr-5">
                            <v-switch
                                v-model="question.questionStatus"
                                inset
                                dense
                                class="mt-2" 
                                color="blue"
                                disabled
                                :label="question.questionStatus ? 'Active' : 'Inactive'"
                            >
                            </v-switch>
                        </div>
                    </v-col>
                </v-row>   
            </v-card>
        </div>
      </div>
    </v-container>
</template>

<script>
import TypeOneQuestion from "../../models/TypeOneQuestion";
import TypeTwoQuestion from "../../models/TypeTwoQuestion";
import url1 from '../../../config.js';

export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                 {
                     vm.$router.push("/");
                 }
            }, 0);
        });
    },

    name: "QuestionInfo",
    props:['question_id', 'questionType' ],
    data() {
        return {
            questionAud:'',
            url:`${url1.url}`,
            typeOneQuestion:undefined,
            question:  undefined             
            }
    },

    methods:{

        getQuestionTypeOne() {
            //console.log('get question client');
            TypeOneQuestion.getQuestionInfo(this.question_id,this.questionType, this.auth.token).then((res)=>{
                //console.log('Get question Client res.data', res.data);
                console.log('question info res.data', res.data);
                this.question=res.data;
                this.questionAud=`${this.url}/uploads/${res.data.questionAudio}`;
                //console.log('Get question, this.question', this.question);
            }).catch(err => console.error(err.response.data));
        },
        getQuestionTypeTwo() {
            //console.log('get question client');
            TypeTwoQuestion.getQuestionInfo(this.question_id,this.questionType, this.auth.token).then((res)=>{
                //console.log('Get question Client res.data', res.data);
                console.log('question info res.data', res.data);
                this.question=res.data;
                this.questionAud=`${this.url}/uploads/${res.data.questionAudio}`;
                //console.log('Get question, this.question', this.question);
            }).catch(err => console.error(err.response.data));
        },
    },

    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },
    mounted() {
        console.log('mounted question');
        if(this.questionType==='1')
        {
            this.question=new TypeOneQuestion;
            this.typeOneQuestion=true;
            this.getQuestionTypeOne();
        }
        else if(this.questionType=='2')
        {
            this.question=new TypeTwoQuestion;
            this.typeOneQuestion=false;
            this.getQuestionTypeTwo();
        }
        
    }
}
</script>

<style scoped>
.custom_question-info >>> header {
    background: transparent !important;
}
.custom_v-card {
    border-top: 3px solid #1b73ba;
}
.v-card__title {
    font-size: 18px;
}
.custom_question-info >>> .v-card__text {
    padding: 10px 16px;
}

.custom_question-info >>> .v-badge__badge.blue{
    height:30px;
    min-width:30px;
    border-radius: 50px;
}
.custom_question-info >>> .mdi-pencil-outline::before{
    font-size:16px;
}
.custom_question-info >>> .v-input__append-outer, .custom_admin-info >>>  .v-input__prepend-outer{
margin-top:9px;
}

</style>